import { it } from 'date-fns/locale/it';
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hooks';
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo";
import { colors } from '../../../ui/colors';
import { EditIcon } from "../../../ui/icons/edit";
import { MapPinIcon } from '../../../ui/icons/mapPin';
import { TrashIcon } from "../../../ui/icons/trash";
import { Dropdown } from "../../../ui/organisms/dropdown";
import { formatterDate } from "../../../utils";
import { CompanyCenterDTO } from '../feature/companyCenter/dto';
import { getCompanyCenterByIds } from "../feature/companyCenter/slice";
import { EditCompanyCenterModal } from './editCompanyCenterModal';
import { DeleteCompanyCenterModal } from './deleteCompanyCenterModal';

registerLocale('it', it)

const COL_HEADERS = [
    'ID / Codice', 'Descrizione', 'Indirizzo', 'Regione', 'Provincia',
    'Città', 'Email', 'Telefono', 'Data Ingresso', 'Data Uscita', '',
]

export function ListCentriAziendaliEdit() {
    const customerState = useAppSelector(state => state.customer)
    const companyCenterState = useAppSelector(state => state.companyCenter)

    const dispatch = useAppDispatch()

    const [showPopup, setShowPopup] = useState(false)
    const [selectedCompanyCenter, setSelectedCompanyCenter] = useState<CompanyCenterDTO | null>(null)
    const [showDeletePopup, setShowDeletePopup] = useState(false)
    const [selectedDeleteId, setSelectedDeleteId] = useState<string | undefined>(undefined)

    useEffect(() => {
        if (customerState.getCustomerByIdStatus === "successfully" && customerState.getCustomerByIdResponse !== undefined && customerState.getCustomerByIdResponse.companyCenterIds && customerState.getCustomerByIdResponse.companyCenterIds.length > 0) {
            dispatch(getCompanyCenterByIds(customerState.getCustomerByIdResponse.companyCenterIds))
        }
    }, [customerState.getCustomerByIdStatus])

    if (companyCenterState.companyCenterByIdsStatus === 'loading')
        return <LogoSpinnerComponent fullScreen />

    const centers = companyCenterState.companyCenterByIdsResponse && companyCenterState.companyCenterByIdsResponse.length > 0 ? companyCenterState.companyCenterByIdsResponse : []

    if (centers.filter((center) => center.active).length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-12 text-center">
                <div className="w-12 h-12 rounded-full bg-brandPrimary-100 flex items-center justify-center mb-3">
                    <MapPinIcon color={colors.brandPrimary[500]} size={20} />
                </div>
                <p style={{ fontFamily: 'Manrope' }} className="text-sm font-semibold text-neutral-600">
                    Nessun centro aziendale
                </p>
                <p style={{ fontFamily: 'Manrope' }} className="text-xs text-neutral-400 mt-1">
                    Aggiungi il primo centro aziendale usando il pulsante in basso.
                </p>
            </div>
        )
    }

    return (
        <>
            <div className="w-full max-w-full min-w-0 rounded-t-2xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="w-full max-w-full overflow-x-auto">
                    <div className="max-h-[420px] overflow-y-auto">
                        <table className="w-max min-w-full table-auto text-sm" style={{ fontFamily: 'Manrope', borderCollapse: 'separate', borderSpacing: 0 }}>
                            <thead className="sticky top-0 z-20">
                                <tr className="bg-brandPrimary-600 text-white">
                                    {COL_HEADERS.map((h, i) => (
                                        <th
                                            key={i}
                                            className="px-4 py-4 text-left text-xs font-semibold uppercase tracking-wide whitespace-nowrap"
                                            style={{
                                                width: i === COL_HEADERS.length - 1 ? '64px' : 'auto',
                                            }}
                                        >
                                            {h}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-neutral-100">
                                {centers.filter((center) => center.active).map((center, index) => (
                                    <tr
                                        key={index}
                                        className={[
                                            'transition-colors duration-150 align-middle',
                                            index % 2 === 0 ? 'bg-white' : 'bg-neutral-50',
                                            'hover:bg-brandPrimary-25',
                                        ].join(' ')}
                                    >
                                        {[
                                            center.code,
                                            center.description,
                                            center.address,
                                            center.countryRegion,
                                            center.province,
                                            center.city,
                                            center.email,
                                            center.phone,
                                            formatterDate(center.activationDate),
                                            formatterDate(center.deactivationDate),
                                        ].map((val, ci) => (
                                            <td
                                                key={ci}
                                                className="px-4 py-4 text-neutral-700 font-medium whitespace-nowrap text-left"
                                                title={typeof val === 'string' ? val : undefined}
                                            >
                                                {val || <span className="text-neutral-300">—</span>}
                                            </td>
                                        ))}
                                        <td className="px-3 py-4">
                                            <Dropdown portaled items={[
                                                {
                                                    label: 'Modifica',
                                                    icon: <EditIcon color="" size={0} />,
                                                    onClick: () => {
                                                        setSelectedCompanyCenter(center)
                                                        setShowPopup(true)
                                                    },
                                                },
                                                {
                                                    label: 'Elimina',
                                                    icon: <TrashIcon color="" size={0} />,
                                                    onClick: () => {
                                                        setSelectedDeleteId(center.id)
                                                        setShowDeletePopup(true)
                                                    },
                                                },
                                            ]} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {
                showPopup && selectedCompanyCenter &&
                <EditCompanyCenterModal
                    companyCenter={selectedCompanyCenter}
                    closeHandler={() => setShowPopup(false)}
                />
            }
            <DeleteCompanyCenterModal
                visible={showDeletePopup}
                id={selectedDeleteId}
                onClose={() => {
                    setShowDeletePopup(false)
                    setSelectedDeleteId(undefined)
                }}
            />
        </>
    )
}